




















































































































































import Vue from "vue";
import Component from "vue-class-component";
import { QuestionModel, QuizResponse, Subject } from "@/model/ResponseModel";
@Component({
  name: "AWS",
  watch: {
    $route(to, from) {
      if (to.query.title !== from.query.title) {
        this.$store.state.aws.quiz = (this.$store.state
          .quizzes as QuizResponse).subjects.filter(
          value => value.name === this.$route.query.title
        )[0] as Subject;
        this.$emit("ROUTE CHANGE", to);
      }
    }
  }
  // Toutes les options de composant sont autorisées ici.
})
export default class AWS extends Vue {
  title = "";
  test = [];
  rightAnswer = 0;
  unanswerOnly = false;
  created() {
    this.$store.state.aws.quiz = (this.$store.state
      .quizzes as QuizResponse).subjects.filter(
      value => value.name === this.$route.query.title
    )[0] as Subject;
  }
  mounted() {
    this.rightAnswer = this.getNumberOfRightAnswer();
    this.$on("ROUTE CHANGE", () => {
      this.rightAnswer = this.getNumberOfRightAnswer();
    });
  }
  showResult(item: QuestionModel) {
    item.showResult = !item.showResult;
  }
  respondQuestion(item: QuestionModel) {
    let valid = true;
    for (const response of item.responses) {
      if (response.isTrue && !response.chose) {
        item.isFalse = true;
        item.isTrue = false;
        valid = false;
      } else if (response.isFalse && response.chose) {
        item.isFalse = true;
        item.isTrue = false;
        valid = false;
      }
    }
    if (valid) {
      item.isTrue = true;
      item.isFalse = false;
    }
    this.rightAnswer = this.getNumberOfRightAnswer();
    localStorage.setItem("quizzes", JSON.stringify(this.$store.state.quizzes));
  }

  getNumberOfRightAnswer() {
    let count = 0;
    for (const question of this.$store.state.aws.quiz
      .questions as QuestionModel[]) {
      if (question.isTrue) {
        count += 1;
      }
    }
    return count;
  }
  resetQuiz() {
    for (const question of this.$store.state.aws.quiz
      .questions as QuestionModel[]) {
      question.isTrue = false;
      question.isFalse = false;
      for (const r of question.responses) {
        r.chose = false;
      }
    }
    this.rightAnswer = this.getNumberOfRightAnswer();
    localStorage.setItem("quizzes", JSON.stringify(this.$store.state.quizzes));
  }
}
